/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntryType } from './entryType';


export interface OffeneArchivierungenResponse { 
    list?: Array<EntryType>;
    total?: number;
}

